module.exports = __webpack_public_path__ + "static/img/active5.1041a721.png";